export default {
  setMigrationDialogHeader: 'Start der Migration festlegen',
  setMessage: 'Sind Sie sicher, dass Sie den Migrationsstatus für {count} {type} zurücksetzen wollen?\n'
    + 'Infolgedessen werden alle {type} ab dem {date} migriert.',
  setMigrationDialogErrorPast: 'Der gewählte Zeitpunt muss in der Vergangenheit liegen.',
};
